import { render, staticRenderFns } from "./ProcessOrderWrapper.vue?vue&type=template&id=81581898&"
import script from "./ProcessOrderWrapper.vue?vue&type=script&lang=js&"
export * from "./ProcessOrderWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports